// extracted by mini-css-extract-plugin
module.exports = {"h8v96vm":"h8v96vm","time":"time","tqazqjf":"tqazqjf","c1tdwk3z":"c1tdwk3z","h1l6qn6g":"h1l6qn6g","t1u31rnp":"t1u31rnp"};